import styled from '@emotion/styled';

export const CodeHighlight = styled.span`
  color: aqua;
`;

export const CodeContainer = styled.div`
  white-space: pre;
  font-family: monospace;
  background-color: #002244;
  padding: 2rem;
  color: white;
  margin-top: 1rem;
  font-size: 1.5rem;
  overflow: auto;
`;
